export function initializeNavbar() {
  function adjustDropdownPosition() {
    $(".nav__dropdown").each(function () {
      var $menu = $(this);
      var offset = $menu.offset();
      var menuWidth = $menu.outerWidth(true);
      var windowWidth = $(window).width();

      if (offset.left + menuWidth > windowWidth) {
        $menu.css({
          left: "auto",
          right: "0",
        });
      } else {
        $menu.css({
          left: "",
          right: "",
        });
      }
    });
  }

  $(".nav__dropdown-fullwidth__menu__link").hover(function (e) {
    e.preventDefault();
    const targetId = $(this).data("id");
    const parent = $(this).closest(".nav__dropdown-fullwidth");
    const targetSubmenu = parent.find(
      ".nav__dropdown-fullwidth__submenu#" + targetId
    );
    const link = $(this);
    const allLinks = parent
      .find(".nav__dropdown-fullwidth__menu__link")
      .not(link);
    const allSubmenus = parent
      .find(".nav__dropdown-fullwidth__submenu")
      .not(targetSubmenu);

    allLinks.removeClass("active");
    link.addClass("active");

    allSubmenus.removeClass("active");
    targetSubmenu.addClass("active");
  });

  // Prevent clicks on dropdown menu links
  $(".nav__dropdown-fullwidth__menu__link").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

  $(".mobile-nav__link-childs").click(function (e) {
    e.preventDefault();
    $(this)
      .next(".mobile-nav__sublist")
      .toggleClass("mobile-nav__sublist-opened");
    $(this)
      .find(".mobile-nav__button")
      .toggleClass("mobile-nav__button-opened");
  });

  $(".footer-menu__link-childs").click(function (e) {
    e.preventDefault();
    $(this)
      .next(".footer-menu__dropdown")
      .toggleClass("footer-menu__dropdown-opened");
    $(this)
      .find(".footer-menu__button")
      .toggleClass("footer-menu__button-opened");
  });

  $("#navbar-toggle").click(function (event) {
    $(".mobile-nav, body").toggleClass("opened");
    event.preventDefault();
  });

  adjustDropdownPosition();

  $(window).resize(function () {
    let windowWidth = $(window).width();

    if ($("body").hasClass("opened") && windowWidth > 1199) {
      $("body, .mobile-nav").removeClass("opened");
    }
    adjustDropdownPosition();
  });
}
